import { setGetMailingAction } from '../action';
import {getMailing } from '../api/getMailing';

export const setGetMailing = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailing(params);

            dispatch(setGetMailingAction({
                ...data,
                pagination: {
                    totalPage: Number(data?.pagination?.totalPage || 0),
                    currentPage: Number(data?.pagination?.currentPage || 0),
                    totalSize: Number(data?.pagination?.totalSize || 0),
                    pageSize: Number(data?.pagination?.pageSize || 0)
                }
            }))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}